<template>
  <v-card width="100%" class="rounded-4" flat outlined>
    <v-sheet
      color="grey lighten-1"
      class="rounded-t-4 rounded-b-0 image-wrapper"
      tile
    >
      <v-skeleton-loader
        width="100%"
        height="100%"
        class="rounded-t-4 rounded-b-0 absolute top-0 bottom-0 left-0 right-0"
      ></v-skeleton-loader>
    </v-sheet>
    <v-sheet height="72" tile color="white" class="rounded-b-4"></v-sheet>
  </v-card>
</template>

<script>
export default {
  name: "SearchDestinationCardLoading"
};
</script>
<style>
.image-wrapper {
  position: relative;
  padding-top: 61.8%;
  width: 100%;
}
</style>
